import { Component } from '@angular/core';

@Component({
    selector: 'canned-response',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CannedResponseComponent {}
